/*
 * Early Access countdown.
 *
 * Reads a target date entered in Turkish format (GG.AA.YYYY SS:DD) from the
 * data-target attribute, interprets it as Turkey local time (UTC+03:00) and
 * counts down to it. Updates day/hour/minute/second values every second.
 */
(function () {
  function parseTurkishDate(value) {
    if (!value) return null;

    var trimmed = value.trim();
    var parts = trimmed.split(/\s+/);
    var datePart = parts[0];
    var timePart = parts[1] || '00:00';

    var dateBits = datePart.split('.');
    if (dateBits.length !== 3) return null;

    var day = parseInt(dateBits[0], 10);
    var month = parseInt(dateBits[1], 10);
    var year = parseInt(dateBits[2], 10);

    var timeBits = timePart.split(':');
    var hours = parseInt(timeBits[0], 10) || 0;
    var minutes = parseInt(timeBits[1], 10) || 0;
    var seconds = parseInt(timeBits[2], 10) || 0;

    if (!day || !month || !year) return null;

    // Build an ISO string pinned to Turkey time (UTC+03:00) so the countdown
    // is identical for every visitor regardless of their own timezone.
    var iso =
      pad(year, 4) +
      '-' +
      pad(month, 2) +
      '-' +
      pad(day, 2) +
      'T' +
      pad(hours, 2) +
      ':' +
      pad(minutes, 2) +
      ':' +
      pad(seconds, 2) +
      '+03:00';

    var date = new Date(iso);
    return isNaN(date.getTime()) ? null : date;
  }

  function pad(num, size) {
    var str = String(num);
    while (str.length < size) str = '0' + str;
    return str;
  }

  function initCountdown(root) {
    var target = parseTurkishDate(root.dataset.target);
    var expired = root.querySelector('.early-access__expired');
    var grid = root.querySelector('.early-access__countdown');

    var elements = {
      days: root.querySelector('[data-count="days"]'),
      hours: root.querySelector('[data-count="hours"]'),
      minutes: root.querySelector('[data-count="minutes"]'),
      seconds: root.querySelector('[data-count="seconds"]'),
    };

    if (!target) {
      if (grid) grid.style.display = 'none';
      return;
    }

    function showExpired() {
      if (grid) grid.style.display = 'none';
      if (expired) expired.hidden = false;
    }

    function tick() {
      var diff = target.getTime() - Date.now();

      if (diff <= 0) {
        if (elements.days) elements.days.textContent = '00';
        if (elements.hours) elements.hours.textContent = '00';
        if (elements.minutes) elements.minutes.textContent = '00';
        if (elements.seconds) elements.seconds.textContent = '00';
        showExpired();
        clearInterval(timer);
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (elements.days) elements.days.textContent = pad(days, 2);
      if (elements.hours) elements.hours.textContent = pad(hours, 2);
      if (elements.minutes) elements.minutes.textContent = pad(minutes, 2);
      if (elements.seconds) elements.seconds.textContent = pad(seconds, 2);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  /* --------------------------------------------- Click-to-enter transition */

  function initClickTransition(root) {
    var targetUrl = root.dataset.url || '/collections/all';
    var transition = root.dataset.transition || 'dissolve';
    var animating = false;

    root.addEventListener('click', function (evt) {
      if (animating) return;
      if (window.Shopify && window.Shopify.designMode) return;

      // Ignore clicks on interactive elements (form, inputs, buttons, links).
      if (evt.target.closest('a, button, input, textarea, select, label, form, .early-access__form-wrap')) {
        return;
      }

      animating = true;
      sessionStorage.setItem('qo-door-transition', '1');
      sessionStorage.setItem('qo-show-early-access-popup', '1');

      if (transition === 'door') {
        playDoorTransition(root, targetUrl);
      } else if (transition === 'zoom') {
        playSimpleTransition(root, 'banner-zoom', 800, targetUrl);
      } else {
        playSimpleTransition(root, 'banner-dissolve', 800, targetUrl);
      }
    });
  }

  function playSimpleTransition(root, animClass, delay, targetUrl) {
    requestAnimationFrame(function () {
      root.classList.add(animClass);
    });
    setTimeout(function () {
      window.location.href = targetUrl;
    }, delay);
  }

  function playDoorTransition(root, targetUrl) {
    var contentHTML = root.innerHTML;

    var doorLeft = document.createElement('div');
    doorLeft.className = 'homepage-banner__door homepage-banner__door--left';
    var leftContent = document.createElement('div');
    leftContent.className = 'homepage-banner__door-content';
    leftContent.innerHTML = contentHTML;
    doorLeft.appendChild(leftContent);

    var doorRight = document.createElement('div');
    doorRight.className = 'homepage-banner__door homepage-banner__door--right';
    var rightContent = document.createElement('div');
    rightContent.className = 'homepage-banner__door-content';
    rightContent.innerHTML = contentHTML;
    doorRight.appendChild(rightContent);

    root.style.visibility = 'hidden';
    document.body.appendChild(doorLeft);
    document.body.appendChild(doorRight);

    requestAnimationFrame(function () {
      doorLeft.classList.add('door-animate-left');
      doorRight.classList.add('door-animate-right');
    });

    setTimeout(function () {
      window.location.href = targetUrl;
    }, 700);
  }

  function init() {
    document.querySelectorAll('.early-access').forEach(function (root) {
      if (root.dataset.target) initCountdown(root);
      initClickTransition(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
